import { useEffect, useState } from 'react';

const useDebounce = (value, delay = 0) => {
    const [val, setVal] = useState(value);

    useEffect(() => {
        const timeoutId = setTimeout(() => setVal(value), delay)
        return () => clearTimeout(timeoutId)
    }, [value])

    return val;
}

export default useDebounce;
